import { LessonItemType } from '@/utils/lesson/lessonItems';
import { CourseLessonRoute, ROUTES } from '@/utils/routes';

export const LESSON_TAB_PATHS = {
  instruction: 'instructions',
  resources: 'resources',
  material: 'material',
  challenge: 'challenges',
  activity: 'activities',
  teacherBook: 'teacher-material',
} as const satisfies Partial<Record<LessonItemType, string>>;

type RoutedLessonItemType = keyof typeof LESSON_TAB_PATHS;

const isRoutedLessonTab = (
  type: LessonItemType,
): type is RoutedLessonItemType => type in LESSON_TAB_PATHS;

export const toLessonTabHref = (
  { slug, lessonId, klassId }: CourseLessonRoute,
  type: LessonItemType,
) => {
  if (!isRoutedLessonTab(type)) return undefined;

  const basePath = ROUTES.COURSES.LESSON.INFO(slug, lessonId, klassId);

  return `${basePath}/${LESSON_TAB_PATHS[type]}`;
};
